module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAS1JREFUOBHtlD1OA0EMhRlAdLlAhHIBGqSkJhEHoCUSHTV3iLhJzsAJNtQUFMkFUlDBCfhZvqd4VjPWbmaLlLH05Hn2s8frXW046WF1XV8huzHpawhhUyo7LQloOkezBmPDO7H7Ut3evCYF3+A6CnUGMj1FpwVlEE1xM52dTeBD8OLid/AP8ObiohWrWp27hC7QZZXF2wqV8hf5Ois3x+QL8JxHy6ytrvjyym3bFcXGTDMVYrnnMe6937HPi88suDLvuYVzV5w4l/dnx8bNro6raFbR5zuuGvXu4LlL76hvrJ3/pEr9qfZxy/3iz1Kdf3lfJG9TQc/zE7rPVKtfZGP8By4gEgzAAmRTwL1p0gdwCQY83V8UZI1jkAseOY9AHWMdXvVbsEybdmgPE/4H5zVgbe7EKFYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/wrongbank_icon_del.png
// module id = ackt
// module chunks = 0